import React, { useContext } from "react";
import { Container, Row, Col, NavDropdown } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import navBarCss from "./../css/navBarCss.module.css";
import { Contaxt } from "../../../Store";

const Navigation = () => {
  const { pathname } = useLocation();
  const { menuItems } = useContext(Contaxt);

  return (
    <nav>
      <Container fluid>
        <Row>
          <div className="navigation">
            <Navbar expand="lg">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <ul className="navbar-nav">
                  {menuItems.map((item, index) => {
                    if (item.menu_title === "Career") {
                      return (
                        <li key={item.id || index}>
                          <NavDropdown title="Career" id="basic-nav-dropdown">
                            <NavDropdown.Item className="border-bottom p-1">
                              <Link to="/career">Job Opportunities</Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item className="p-1">
                              <Link to="/shareCV">Share Resume</Link>
                            </NavDropdown.Item>
                          </NavDropdown>
                        </li>
                      );
                    } else {
                      return (
                        <li key={item.id || index}>
                          {item.urlType === "internal" ? (
                            <Link
                              className={pathname === item.slug ? navBarCss.ActiveButton : ""}
                              to={item.slug}
                            >
                              {item.menu_title}
                            </Link>
                          ) : (
                            <a href={item.slug} target="_blank" rel="noopener noreferrer">
                              {item.menu_title}
                            </a>
                          )}
                        </li>
                      );
                    }
                  })}
                </ul>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </Row>
      </Container>
    </nav>
  );
};

export default React.memo(Navigation);
